import { createAction, props, union } from '@ngrx/store';
import { PayrollSelectFilter } from '../payroll.types';

const source = 'payroll';
const actions = 'ui';

export const payrollSetSelectedTab = createAction(
  `[${source}][${actions}] Set Selected Tab`,
  props<{ selectedTab: number }>()
);


export const payrollSetSelectedYears = createAction(
  `[${source}][${actions}] Set Selected Years`,
  props<{ selectedYears: string[] }>()
);

export const payrollSetSelectedFilter = createAction(
  `[${source}][${actions}] Set Filter`,
  props<{ selectedFilter: PayrollSelectFilter[], selectedFilterKeys: string[] }>()
);

export const payrollSetSelectedFilterSynthese = createAction(
  `[${source}][${actions}] Set Filter Synthese`,
  props<{ selectedFilterSynthese: string }>()
);

export const payrollSetViewTypeSynthese = createAction(
  `[${source}][${actions}] Set ViewType Synthese`,
  props<{ selectViewTypeSynthese: string }>()
);

const all = union({
  payrollSetSelectedTab,
  payrollSetSelectedYears,
  payrollSetSelectedFilter,
  payrollSetSelectedFilterSynthese,
  payrollSetViewTypeSynthese
});

export type PayrollUIActionsUnion = typeof all;
